import React, { useEffect, useState } from "react";
import { Zoom, Box, Fade, Typography, IconButton, Button } from "@mui/material";
import { ArrowForward, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export default function Answer(props) {
  const { t } = useTranslation();

  const [textChunks, setTextChunks] = useState([]);

  const [currentChunk, setCurrentChunk] = useState(0);
  const [finished, setFinished] = useState(false);
  const [forwardButtonVisible, setForwardButtonVisible] = useState(true);
  const [slideToggler, setSildeToggler] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    setTextChunks(splitTextIntoChunks(props.text, 1));
    setCurrentChunk(0);
  }, [props.text]);

  useEffect(() => {
    if (currentChunk >= textChunks.length) {
      setForwardButtonVisible(false);
    } else {
      setForwardButtonVisible(true);
    }
  }, [currentChunk, textChunks.length]);

  const splitTextIntoChunks = (text, size) => {
    let strings = [];
    let index = 0;
    let splittedString = text.split(". ");
    while (index < splittedString.length) {
      let chunk = [];
      for (let i = index; i < size + index; i++) {
        chunk.push(splittedString[i]);
      }
      if (index !== splittedString.length - 1)
        strings.push(chunk.join(". ") + ".");
      else {
        strings.push(chunk.join(". "));
      }
      index += size;
    }
    return strings;
  };

  useEffect(() => {
    console.log(finished);
  }, [finished]);

  const incrementChunk = () => {
    setSildeToggler(false);
    setTimeout(() => {
      setSildeToggler(true);
    }, 200);
    if (textChunks.length - 1 === currentChunk) {
      setFinished(true);
      setForwardButtonVisible(false);
    } else {
      setCurrentChunk(currentChunk + 1);
    }
  };

  return (
    <Zoom in={true} style={{ transitionDelay: 500 }}>
      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography sx={{color: "success.main"}}>Richtig!</Typography>
        <Box sx={{display: "flex", alignItems: "center"}}>
          <Fade direction="right" in={slideToggler} exit={false}>
            <Box
              sx={{
                display: "inline-flex",
                width: "60%",
                margin: "auto",
                padding: 2,
              }}
            >
              {!finished ? (
                <Typography align="center" variant="subtitle2">
                  {textChunks[currentChunk]}
                </Typography>
              ) : (
                <Box>
                  <Button
                    size="small"
                    sx={{ marginBottom: 1 }}
                    color="primary"
                    onClick={props.unanswer}
                    variant="contained"
                  >
                    {t("welcomeQuizButton1")}
                  </Button>
                  <Button
                    size="small"
                    color="secondary"
                    onClick={() => navigate("/learning")}
                    variant="contained"
                    startIcon=<ArrowForward/>
                  >
                    {t("welcomeQuizButton2")}
                  </Button>
                </Box>
              )}
            </Box>
          </Fade>
          {forwardButtonVisible && (
            <IconButton
              onClick={incrementChunk}
              color="primary"
              variant="contained"
              size="large"
              sx={{
                display: "inline-flex",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
            >
              <ArrowForwardIos fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>
    </Zoom>
  );
}
